import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import { getViewGroup, getViewGroupReport } from '@/apis/sheet'
import { bar, columnar, line, pie, sunburst, funnel, map, gantt } from './chart/render'
@Component({
  name: 'sheetCommon'
})
export default class extends Vue {
  public async searchFilterList(id) {
    const res = await getViewGroup(id)
    return res.data.viewComponents
  }
  public async searchFilterListReport(id) {
    const res = await getViewGroupReport(id)
    return res.data.viewComponents
  }
  public newChart(item, chart) {
    const { reportConfigDTO = {}, } = item
    switch (reportConfigDTO.reportType) {
      case 'bar':
        bar(chart, item, reportConfigDTO.displayConfig)
        break
      case 'columnar':
        columnar(chart, item, reportConfigDTO.displayConfig)
        break
      case 'line':
        line(chart, item, reportConfigDTO.displayConfig)
        break
      case 'pie':
        pie(chart, item, reportConfigDTO.displayConfig)
        break
      case 'funnel':
        funnel(chart, item, reportConfigDTO.displayConfig)
        break
      case 'sunburst':
        sunburst(chart, item, reportConfigDTO.displayConfig)
        break
      case 'map':
        map(chart, item, reportConfigDTO.displayConfig)
        break
      case 'gantt':
        gantt(chart, item, reportConfigDTO.displayConfig)
      default:

    }
    return chart
  }
}
